import { getObjectByPrefix } from '../utils/object';
import keys from '../utils/keys';

export const getButtonProps = (props, prefix = 'button') =>
  mapKeysToProps(keys('ButtonProps'), getObjectByPrefix(prefix, props));

export const mapKeysToProps = (keys, propsIn) => {
  return keys
    ? keys.reduce((newObj, key) => {
        if (propsIn[key] !== undefined && key !== 'children') {
          newObj[key] = propsIn[key];
        }

        return newObj;
      }, {})
    : {};
};
